"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = Description;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledSpan = (0, _material.styled)('span')(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'block',
    textWrap: 'wrap'
  };
});
function Description(_ref2) {
  var text = _ref2.text,
    _ref2$length = _ref2.length,
    length = _ref2$length === void 0 ? 400 : _ref2$length;
  return /*#__PURE__*/_react["default"].createElement(StyledSpan, {
    style: {
      maxWidth: "".concat(length, "px")
    }
  }, text || '---');
}